import {
  ApiClient,
  ApiClientContext,
  ApiClientOptions,
  RouteOptions,
  defaultAxiosConfig,
} from '@qualifio/api-client';
import { AxiosInstance } from 'axios';
import { CampaignFeedChannel } from './types/campaign-feed-channel';

export class CampaignFeedApiClient extends ApiClient {
  static serviceName = 'campaign-feed-api';

  constructor(http?: AxiosInstance, context?: ApiClientContext, options?: ApiClientOptions) {
    super('/v1/campaignfeed', http, context, options);
  }

  async getChannels(feedUuid: string, options?: RouteOptions): Promise<CampaignFeedChannel[]> {
    const { data } = await this.http.get(
      `/channels/${feedUuid}/json?channelOrder=DESC`,
      defaultAxiosConfig(options),
    );
    return data.channels;
  }

  async getFeed(id: string, n?: number): Promise<CampaignFeedChannel[]> {
    const channels = await this.getChannels(id);
    const subset = n === undefined ? channels : channels.slice(0, n);
    for (const channel of subset) {
      channel.integration.javascript = channel.integration.javascript
        // Avoid reloading qualp everytime (loaded at start of get-participant)
        ?.replace(
          "(document,window,'_qual_async','script','//demo.qualifioapp.com/kit/qualp.2.min.js');",
          '',
        )
        // Avoid annoying resizing
        .replace(
          /'100%', '\d+', '', '', '', 'max-width:810px;margin:0 auto;']/,
          "'100%', '0', '', '', '', 'max-width:100%;margin:0 auto;']",
        );
    }
    return subset;
  }
}
